import React, { useEffect, useState, useCallback, useRef } from "react";
import { useTranslation } from "ceco-polyglot";
import { Header } from "../../components/cecoadmin-panel";
import FullWidthLayout from "../../layout/FullWidthLayout";
import CreateButton from "../../components/CreateButton";
import { AllergensTable } from "../../components/tables/AllergensTable";
import { Dimmer, Loader } from "semantic-ui-react";
import graphql from "babel-plugin-relay/macro";
import { createPaginationContainer } from "react-relay";

const AllergensPage = (props) => {
  const {
    menuExpanded,
    setMenuExpanded,
    children,
    allCategories,
    relay,
    allAllergen,
    ...rest
  } = props;
  const [search, setSearch] = useState();
  const { totalCount, edges } = allAllergen.allAllergen;
  const [isLoading, setIsLoading] = useState(false);
  const loadSearch = useRef(false);

  const allergensParsed = edges.map((allergen, i) => {
    return {
      ...allergen.node,
    };
  });

  const t = useTranslation();
  useEffect(() => {
    document.title = `Recetario Mambo - ${t("title.allergens")}`;
  }, [t]);

  const _loadMore = () => {
    if (!relay.hasMore() || relay.isLoading()) {
      return;
    }
    setIsLoading(true);
    relay.loadMore(20, () => {
      setIsLoading(false);
    });
  };

  const _refetch = () => {
    setIsLoading(true);

    relay.refetchConnection(
      search === "" || search === undefined ? 20 : null,
      () => setIsLoading(false),
      {
        name: search === "" || search === undefined ? null : search,
      }
    );
  };

  const handleScroll = (e) => {
    const target = e.target;
    if (target.scrollHeight - target.scrollTop === target.clientHeight) {
      _loadMore();
    }
  };

  const onSearchText = useCallback(
    (txt) => {
      setSearch(txt);
    },
    [setSearch]
  );

  useEffect(() => {
    if (loadSearch.current) {
      setIsLoading(true);

      relay.refetchConnection(
        search === "" || search === undefined ? 20 : null,
        () => setIsLoading(false),
        {
          name: search === "" || search === undefined ? null : search,
        }
      );
    }
    loadSearch.current = true;
  }, [relay, search]);

  return (
    <FullWidthLayout>
      <Header
        title={t("title.allergens")}
        menuExpanded={menuExpanded}
        setMenuExpanded={setMenuExpanded}
        onSearchTextChange={onSearchText}
      >
        <CreateButton allCategories={allCategories} refetchData={_refetch} />
      </Header>

      <div className="table-wrapper">
        <>
          <AllergensTable
            allergensParsed={allergensParsed}
            totalCount={totalCount}
            _refetch={_refetch}
            handleScroll={handleScroll}
            {...rest}
          />
          {isLoading && (
            <Dimmer inverted active>
              <Loader indeterminate />
            </Dimmer>
          )}
        </>
      </div>
    </FullWidthLayout>
  );
};

export default createPaginationContainer(
  AllergensPage,
  {
    allAllergen: graphql`
      fragment AllergensPage_allAllergen on Query
        @argumentDefinitions(
          name: { type: "String" }
          count: { type: "Int", defaultValue: 20 }
          cursor: { type: "String" }
        ) {
        allAllergen(name: $name, first: $count, after: $cursor)
          @connection(key: "Allergens_allAllergen") {
          totalCount
          edges {
            node {
              id
              name
              image
              color
            }
          }
        }
      }
    `,
  },
  {
    direction: "forward",
    getConnectionFromProps(props) {
      return props.allAllergen && props.allAllergen.allAllergen;
    },

    getFragmentVariables(prevVars, totalCount) {
      return {
        ...prevVars,
        count: totalCount,
      };
    },
    getVariables(props, { count, cursor }, fragmentVariables) {
      return {
        count,
        cursor,
      };
    },
    query: graphql`
      query AllergensPagePaginationQuery(
        $count: Int
        $cursor: String
        $name: String
      ) {
        ...AllergensPage_allAllergen
          @arguments(count: $count, cursor: $cursor, name: $name)
      }
    `,
  }
);
